// extracted by mini-css-extract-plugin
module.exports = {"tab":"_80ad21f8ef--tab--3WYVG","next-tab-active":"_80ad21f8ef--next-tab-active--QJtQ5","active":"_80ad21f8ef--active--3YNUW","disabled":"_80ad21f8ef--disabled--3jNLb"};